<!--
 * @Author: Wangchaoke
 * @Date: 2019-11-18 15:48:22
 * @LastEditTime: 2022-08-02 11:17:18
 * @Description: 本页面主要用于播放哈佛视频页面
 * @FilePath: /views/activity/harvard/detail.vue
 -->
<template>
  <div class="wrap" style="background: #fff" @click="closeCommentInput">
    <!-- 小程序环境隐藏返回导航 -->
    <span v-if="!checkFromMiniprogram" class="gobackBtn" @click="goBack">
      <van-icon name="arrow-left" />
    </span>
    <span v-if="!checkFromMiniprogram" class="gobackBtn2" @click="goBack"
      ><img
        alt=""
        class="backimg"
        src="./../../../assets/images/icon/back1.png"
    /></span>

    <!-- 哈佛视频Begin -->
    <HFVideo
      ref="HFVideo"
      :CRMID="CRMID"
      :currentTopicList="currentTopicList"
      :isGoLogin="isGoLogin"
      :isPreventFlag="preventFlag"
      :memberLevel="gread"
      :videoDetail="videoDetail"
    ></HFVideo>
    <!-- 哈佛视频Over -->

    <div v-show="detailShow">
      <!-- 视频详情信息 Begin -->
      <div v-if="videoDetail" id="VideoIntroduce">
        <p class="videoContent">
          <span>{{ videoDetail.videoTitle }}</span>
        </p>
        <!-- 小程序环境隐藏分享按钮 -->
        <p v-if="!checkFromMiniprogram" class="share" @click="HFshare(true, 1)">
          <img
            alt=""
            src="./../../../assets/images/activity/harvard/share3.png"
          />
          <span>分享</span>
        </p>
      </div>
      <!-- 视频详情信息 Over -->

      <!-- 医生信息 Begin -->
      <div v-if="videoDetail" class="doctorTipsBox">
        <div class="doctorTips">
          <div>
            <img :src="doctorDetail.imgUrl" alt="" />
          </div>
          <div>
            <p>{{ doctorDetail.name }}</p>
            <p>{{ doctorDetail.level }}</p>
          </div>
          <div>{{ fomatterNum(videoDetail.initViews) }} 播放</div>
        </div>
      </div>
      <!-- 医生信息 Over -->

      <!-- 视频专题 Begin -->
      <div v-if="currentTopicList" id="special">
        <!-- 视频专题列表 Begin -->
        <featuresCard
          :baseParams="{ noLine: true, collection: true, nowWatch: true }"
          :curPlayVideoId="curVideoId"
          :playType="1"
          :special="currentTopicList"
          @playCur="playCurVideo"
          @playCurTopic="openAllVideo"
        ></featuresCard>
      </div>
      <!-- 视频专题 Over -->

      <!-- 小程序环境隐藏小黑板问答 -->
      <!-- 小黑板Begin -->
      <div v-if="!checkFromMiniprogram && Questions" id="blackboard">
        <div>
          <img
            alt=""
            src="./../../../assets/images/activity/harvard/blackboald.png"
          />
          <p>{{ Questions.question }}</p>
          <button v-if="!isTrue" class="success" @click="btnTrue()">
            <van-icon name="success" />
          </button>
          <button v-if="!isTrue" class="cross" @click="btnFalse()">
            <van-icon name="cross" />
          </button>
          <div v-if="isTrue" class="isTrueProgress">
            <div class="momSelect">
              <span>{{ Questions.correctNum }}%妈妈选择</span>
              <span>{{ Questions.errorNum }}%妈妈选择</span>
            </div>
            <div class="momProgress">
              <p :style="{ width: isBlacProgress.queTrue + 'rem' }"></p>
              <p :style="{ width: isBlacProgress.queFalse + 'rem' }"></p>
            </div>
          </div>
        </div>
      </div>
      <!-- 小黑板 Over -->

      <!-- 小程序环境隐藏评论列表 -->
      <!-- 评论Begin -->
      <div v-if="!checkFromMiniprogram && AllComment.length > 0" class="commentWrap">
        <div class="title">
          评论<span class="num">({{ total }})</span>
          <!-- <van-icon name="arrow-down" class="arrow" v-if="!upComShow" @click="openAllComment('1')" /> -->
          <!-- <van-icon name="arrow-up" class="arrow" v-if="upComShow" @click="openAllComment('2')" /> -->
        </div>
        <div
          v-for="(comment, index) in AllComment"
          :key="comment.id"
          class="commentList"
        >
          <span
            v-lazy:background-image="comment.headImg"
            class="commentAvatars"
          ></span>
          <span class="commentName"
            >{{ comment.nickName
            }}<span
              v-if="UserInfo != null && comment.crmId == UserInfo.crm_id"
              class="myComment"
              >我的评论</span
            ></span
          >
          <div
            ref="commentList"
            class="commentText"
            @click="replyComment(comment, '1')"
          >
            <div class="con" v-text="comment.contents"></div>
            <!-- <span class="expand openCon">... <span @click="expandComment($event,1)">展开</span></span> -->
            <!-- <p class="expand closeCon" @click="expandComment($event,2)"><span>收起</span></p> -->
          </div>
          <div class="bottom">
            <span class="time"
              >{{ comment.time
              }}<span
                v-if="UserInfo != null && comment.crmId == UserInfo.crm_id"
                class="delete"
                @click="dialogToast(comment, '1')"
                >删除</span
              ></span
            >
            <span
              class="commentLike"
              @click="
                support(index, '2', comment.id, comment.crmId, comment.id)
              "
            >
              <van-icon
                v-if="!comment.isLikes"
                color="#999"
                name="good-job-o"
              />
              <van-icon v-else color="#D7AB3A" name="good-job" />
              <span v-if="comment.likes != 0 && comment.likes != null">{{
                fomatterNum(comment.likes)
              }}</span>
            </span>
            <span class="commentBox" @click="replyComment(comment, '1')">
              <img alt="" src="./../../../assets/images/baby/icon1.png" />
            </span>
          </div>
          <!-- 二级回复 -->
          <div v-if="comment.pageBean != null" class="replyComments">
            <div
              v-for="(reply, num) in comment.pageBean.content.slice(0, 2)"
              :key="reply.id"
              class="replyCommentList"
            >
              <div class="replyCommentName">
                <span :style="reply.crmId == '0' ? 'color:#8A9EF3' : ''">{{
                  reply.nickName
                }}</span
                ><img src="./../../../assets/images/baby/icon4.png" /><span
                  :style="reply.replyCrmId == '0' ? 'color:#8A9EF3' : ''"
                  >{{ reply.replyNickName }}</span
                >
              </div>
              <div class="replyCommentText" @click="replyComment(reply, '2')">
                {{ reply.contents }}
              </div>
              <div class="replyBottom">
                <span class="time"
                  >{{ reply.time
                  }}<span
                    v-if="UserInfo != null && reply.crmId == UserInfo.crm_id"
                    class="delete"
                    @click="dialogToast(reply, '2')"
                    >删除</span
                  ></span
                >
                <span
                  class="commentLike"
                  @click="
                    secondSupport(
                      index,
                      num,
                      '3',
                      reply.parentId,
                      reply.crmId,
                      reply.id
                    )
                  "
                >
                  <van-icon
                    v-if="!reply.isLikes"
                    color="#999"
                    name="good-job-o"
                  />
                  <van-icon v-else color="#D7AB3A" name="good-job" />
                  <span v-if="reply.likes != 0 && reply.likes != null">{{
                    fomatterNum(reply.likes)
                  }}</span>
                </span>
                <span class="commentBox" @click="replyComment(reply, '2')">
                  <img alt="" src="./../../../assets/images/baby/icon1.png" />
                </span>
              </div>
              <div
                v-if="comment.pageBean.size != '1' && num != '1'"
                class="border"
              ></div>
            </div>
            <!-- 查看全部评论 -->
            <div
              v-if="comment.pageBean.size > 2"
              class="checkAllCom"
              @click="toReplyCom(comment)"
            >
              查看全部{{ comment.pageBean.size }}条评论
              <van-icon class="arrow" name="arrow" />
            </div>
          </div>
        </div>
        <div v-if="upComShow">
          <van-list
            v-model="listLoading"
            :error.sync="listError"
            :finished="listFinished"
            :finished-text="finishText"
            class="vanlist"
            error-text="请求失败，点击重新加载"
            @load="getUpAllComment(curVideoId)"
          >
            <div
              v-for="(item, index) in upComment"
              :key="item.id"
              class="commentList"
            >
              <span
                v-lazy:background-image="item.headImg"
                class="commentAvatars"
              ></span>
              <span class="commentName"
                >{{ item.nickName
                }}<span
                  v-if="UserInfo != null && item.crmId == UserInfo.crm_id"
                  class="myComment"
                  >我的评论</span
                ></span
              >
              <div
                ref="commentList"
                class="commentText"
                @click="replyComment(item, '1')"
              >
                <div class="con" v-text="item.contents"></div>
                <!-- <span class="expand openCon">... <span @click="expandComment($event,1)">展开</span></span> -->
                <!-- <p class="expand closeCon" @click="expandComment($event,2)"><span>收起</span></p> -->
              </div>
              <div class="bottom">
                <span class="time"
                  >{{ item.time
                  }}<span
                    v-if="UserInfo != null && item.crmId == UserInfo.crm_id"
                    class="delete"
                    @click="dialogToast(item, '1')"
                    >删除</span
                  ></span
                >
                <span
                  class="commentLike"
                  @click="
                    upSupport(index, '2', item.id, item.crmId, item.id, '2')
                  "
                >
                  <van-icon
                    v-if="!item.isLikes"
                    color="#999"
                    name="good-job-o"
                  />
                  <van-icon v-else color="#D7AB3A" name="good-job" />
                  <span v-if="item.likes != 0 && item.likes != null">{{
                    fomatterNum(item.likes)
                  }}</span>
                </span>
                <span class="commentBox" @click="replyComment(item, '1')">
                  <img alt="" src="./../../../assets/images/baby/icon1.png" />
                </span>
              </div>
              <!-- 二级回复 -->
              <div v-if="item.pageBean != null" class="replyComments">
                <div
                  v-for="(replyitem, num) in item.pageBean.content.slice(0, 2)"
                  :key="replyitem.id"
                  class="replyCommentList"
                >
                  <div class="replyCommentName">
                    <span
                      :style="replyitem.crmId == '0' ? 'color:#8A9EF3' : ''"
                      >{{ replyitem.nickName }}</span
                    ><img src="./../../../assets/images/baby/icon4.png" /><span
                      :style="
                        replyitem.replyCrmId == '0' ? 'color:#8A9EF3' : ''
                      "
                      >{{ replyitem.replyNickName }}</span
                    >
                  </div>
                  <div
                    class="replyCommentText"
                    @click="replyComment(replyitem, '2')"
                  >
                    {{ replyitem.contents }}
                  </div>
                  <div class="replyBottom">
                    <span class="time"
                      >{{ replyitem.time
                      }}<span
                        v-if="
                          UserInfo != null && replyitem.crmId == UserInfo.crm_id
                        "
                        class="delete"
                        @click="dialogToast(replyitem, '2')"
                        >删除</span
                      ></span
                    >
                    <span
                      class="commentLike"
                      @click="
                        upSecondSupport(
                          index,
                          num,
                          '3',
                          replyitem.parentId,
                          replyitem.crmId,
                          replyitem.id,
                          '2'
                        )
                      "
                    >
                      <van-icon
                        v-if="!replyitem.isLikes"
                        color="#999"
                        name="good-job-o"
                      />
                      <van-icon v-else color="#D7AB3A" name="good-job" />
                      <span
                        v-if="replyitem.likes != 0 && replyitem.likes != null"
                        >{{ fomatterNum(replyitem.likes) }}</span
                      >
                    </span>
                    <span
                      class="commentBox"
                      @click="replyComment(replyitem, '2')"
                    >
                      <img
                        alt=""
                        src="./../../../assets/images/baby/icon1.png"
                      />
                    </span>
                  </div>
                  <div
                    v-if="item.pageBean.size != '1' && num != '1'"
                    class="border"
                  ></div>
                </div>
                <!-- 查看全部评论 -->
                <div
                  v-if="item.pageBean.size > 2"
                  class="checkAllCom"
                  @click="toReplyCom(item)"
                >
                  查看全部{{ item.pageBean.size }}条评论
                  <van-icon class="arrow" name="arrow" />
                </div>
              </div>
            </div>
          </van-list>
        </div>
        <div v-if="total != 0" class="commentMore" @click="openAllComment('3')">
          <p>
            <span>展开全部{{ total }}条评价</span>
            <van-icon name="arrow" />
          </p>
        </div>
        <div class="commentMore2" @click="openAllComment()">
          <p>
            <span>收起全部评价</span>
            <van-icon name="arrow" />
          </p>
        </div>
      </div>
      <!-- 评论Over -->
      <!-- 专题Begin -->
      <div v-if="topicList.length > 0">
        <div v-for="item in topicList" :key="item.id">
          <featuresCard
            :baseParams="{ nowWatch: true }"
            :curPlayVideoId="curVideoId"
            :playType="2"
            :special="item"
            @playCur="playCurVideo"
            @playCurTopic="openAllVideo"
          ></featuresCard>
        </div>
      </div>
      <!-- 专题Over -->

      <!-- 页脚Begin -->
      <div v-if="currentTopicList" id="footer">
        <img
          alt=""
          src="./../../../assets/images/activity/harvard/footer.png"
        />
      </div>
    </div>
    <!-- 小程序环境隐藏评论输入框 -->
    <!-- 发表评论Begin -->
    <comment-Field
      v-if="!checkFromMiniprogram && videoDetail != null"
      :articalId="curVideoId"
      :carrierId="carrierId"
      :commentTotal="total"
      :currentTop="currentTop"
      :currentTopicList="currentTopicList"
      :isGoLogin="isGoLogin"
      :title="videoDetail.videoTitle"
      :videoDetail="videoDetail"
      :videolike="videolike"
      @getAllComment="getAllComment"
    ></comment-Field>
    <!-- 小程序环境隐藏评论回复输入区 -->
    <!-- 评论输入框 -->
    <div v-show="!checkFromMiniprogram && isFocus" class="centerComment" @click="isBlur()">
      <div
        class="mask"
        @click="isBlur('1')"
        @touchmove.prevent
        @mousewheel.prevent
      ></div>
      <div class="fieldWrap">
        <div class="fieldCon">
          <van-cell-group class="input-item">
            <van-field
              v-model="message"
              :autosize="{ maxHeight: 180, minHeight: 163 }"
              :placeholder="'回复：' + replyNames"
              autofocus
              class="aaa"
              maxlength="200"
              rows="10"
              type="textarea"
              @input="inputChange"
            />
          </van-cell-group>
        </div>
        <div class="fieldTop">
          <!-- <span class="close" @click="isBlur('1')"><img src="./../../../assets/images/activity/harvard/close.png" alt=""></span> -->
          <!-- <span class="title">回复：{{replyNames}}</span> -->
          <span
            class="button"
            @click="message.length > 0 ? secondSubmitAllComment() : ''"
            >提交</span
          >
        </div>
      </div>
    </div>

    <!--<div id="PublishComment" v-if="!isFocus && videoDetail && allCommentFlag">
            <van-search
                class="speak"
                left-icon=""
                placeholder="说出我的观点..."
                shape="round"
                @focus="isFocusFun"
             />-->
    <!-- 点赞 -->
    <!--<figure class="clickSave">
                <div @click="videoSupport()">
                    <van-icon v-if="!videolike.isLike" name="good-job-o" />
                    <van-icon v-else name="good-job" color="#D7AB3A"/>
                </div>
                <figcaption>
                    {{fomatterNum(videolike.videolikes)}}
                </figcaption>
            </figure>-->
    <!-- 分享 -->
    <!--<figure class="commentShare"  @click="HFshare(true,2)">
                <div>
                    <img src="./../../../assets/images/activity/harvard/share2.png" alt="">
                </div>
                <figcaption>
                    分享
                </figcaption>
            </figure>-->
    <!--</div>-->
    <!-- 发表评论Over -->

    <!-- 全部视频 -->
    <all-video
      ref="allVideo"
      :harvardData="harvardData"
      @closeVideo="closeAllVideo"
      @playCurVideo="playCurVideo"
    ></all-video>

    <!-- 小程序环境隐藏全部评论弹窗 -->
    <!-- 全部评论 -->
    <all-comment
      v-if="!checkFromMiniprogram"
      ref="allComment"
      :articalId="curVideoId"
      :carrierId="carrierId"
      :commentFirst="commentFirst"
      :isLogin="isGoLogin"
      :memberLevel="gread"
      @closeCom="closeComment"
      @getAllComment="getAllComment"
    ></all-comment>

    <!-- 发送评论 -->

    <!-- 小程序环境隐藏分享组件 -->
    <!-- 分享 -->
    <HFshare v-if="!checkFromMiniprogram" ref="HFshareVideo"></HFshare>
    <!-- 小程序环境隐藏公众号关注引导 -->
    <!-- 关注 -->
    <Follow v-if="!checkFromMiniprogram && isFollowPublic" :videoDetail="videoDetail"></Follow>

    <!--视频加载中-->
    <div v-if="videoLoadings" id="videoLoading" @touchmove.prevent>
      <img alt="" src="./../../../assets//images/loading.gif" />
    </div>
  </div>
</template>

<style lang="less" scoped>
@import './../../../assets/less/harvard.less';

/*
* 返回按钮样式
*/
.gobackBtn {
  width: 26px;
  position: absolute;
  top: 7px;
  left: 7px;
  z-index: 999;

  .van-icon-arrow-left {
    font-size: @indexFontSize20;
    color: #ffffff;
  }
}

.gobackBtn2 {
  z-index: 100;
  display: none;
  position: fixed;
  width: 26px;
  height: 25px;
  top: 10px;
  left: 7px;

  img {
    width: 26px;
    height: 26px;
  }
}

.fl {
  float: left;
}

.fr {
  float: right;
}

/deep/ .van-list__finished-text {
  background: #fff;
}

/deep/ .swiper-wrapper {
  width: 8000%;

  /deep/ .swiper-slide {
    // height:5rem!important;
    // background:#ff0!important;
    .tit {
      background: #fff !important;
    }
  }
}

/*
* 视频简介
*/
#VideoIntroduce {
  width: 100%;
  height: 52px;
  box-sizing: border-box;
  padding: 0 18px;
  font-size: @fontSize16;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 26px;
  display: flex;
  margin-top: 17px;
  align-items: center;

  .videoContent {
    flex: 1 1 auto; //可放大 可缩小
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .share {
    text-align: center;
    width: 52px;
    flex: 0 0 52px; //不放大 不缩小 固定宽度52px
    cursor: pointer;
    margin-top: 20px;
    .fr;

    img {
      width: 42px;
      height: 42px;
      vertical-align: middle;
      position: relative;
      top: -4px;
    }

    span {
      font-size: @fontSize12;
      color: rgba(153, 153, 153, 1);
      position: relative;
      top: -7px;
    }
  }
}

/**
* 视频医生介绍
*/
.doctorTipsBox {
  padding: 0 18px;
  box-sizing: border-box;

  .doctorTips {
    width: 100%;
    height: 48px;
    margin-top: 12px;
    background: #f4f4f4;
    border-radius: 4px;
    line-height: 48px;
    position: relative;

    div:nth-child(1) {
      .fl;
      width: 33px;
      height: 33px;
      overflow: hidden;
      margin-top: 7px;
      border-radius: 50%;
      margin-left: 12px;

      img {
        width: 100%;
        // height: 100%;
      }
    }

    div:nth-child(2) {
      .fl;
      width: 66%;
      overflow: hidden;
      height: 100%;

      p {
        line-height: 12px;
        margin-left: 9px;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis; /*超出部分显示省略号*/
        white-space: nowrap; /*规定段落中的文本不进行换行 */
      }

      p:nth-child(1) {
        margin-top: 10px;
        color: rgba(51, 51, 51, 1);
        font-weight: 400;
      }

      p:nth-child(2) {
        padding-top: 5px;
        color: rgba(153, 153, 153, 1);
      }
    }

    div:nth-child(3) {
      .fr;
      line-height: 48px;
      color: rgba(153, 153, 153, 1);
      position: absolute;
      right: 15px;
      background: #f4f4f4;
    }
  }
}

/**
* 视频专题
*/
#special {
  margin-top: 19px;
  border-top: 1px solid #cccccc;

  /deep/ .features > .module_title2 {
    border-bottom: 0 solid transparent !important;
  }
}

/**
* 小黑板判断对错样式
*/
#blackboard {
  width: 100%;
  background: rgba(248, 248, 248, 1);
  overflow: hidden;
  text-align: center;
  border-bottom: 10px solid #f8f8f8;

  > div {
    position: relative;
    box-sizing: border-box;
    max-width: 10rem;
    margin: 0 auto;

    img {
      width: 100%;
      padding: 0 17px;
      box-sizing: border-box;
    }

    > p {
      position: absolute;
      top: 69px;
      left: 55px;
      font-size: 12px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 17px;
      width: 256px;
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    .success,
    .cross {
      width: 90px;
      height: 28px;
      outline: none;
      border: none;
      position: absolute;
      border-radius: 14px;
      bottom: 38px;
      box-shadow: 1px 2px 0px 0px rgba(0, 0, 0, 0.28);

      i {
        color: #317c53;
        font-size: 16px;
        line-height: 28px;
      }
    }

    .success {
      background-color: #ffff76;
      left: 80px;
    }

    .cross {
      background-color: #3bffe7;
      right: 80px;
    }

    .isTrueProgress {
      position: absolute;
      bottom: 45px;
      z-index: 5;
      width: 100%;

      div {
        width: 100%;
        box-sizing: border-box;
        padding: 0 53px 0 58px;
        overflow: hidden;
      }

      .momSelect {
        span:nth-child(1) {
          float: left;
          font-size: @fontSize14;
          font-weight: 500;
          color: rgba(255, 255, 59, 1);
          line-height: 20px;
        }

        span:nth-child(2) {
          float: right;
          font-size: @fontSize14;
          font-weight: 500;
          color: rgba(59, 255, 231, 1);
          line-height: 20px;
        }
      }

      .momProgress {
        margin-top: 5px;

        p:nth-child(1) {
          height: 6px;
          background: rgba(255, 255, 118, 1);
          box-shadow: 1px 1px 0px 0px rgba(0, 0, 0, 0.28);
          border-radius: 12px;
          float: left;
        }

        p:nth-child(2) {
          height: 6px;
          background: rgba(59, 255, 231, 1);
          box-shadow: 1px 1px 0px 0px rgba(0, 0, 0, 0.28);
          border-radius: 12px;
          float: right;
        }
      }
    }
  }
}

/**
* 评论
*/
.commentWrap {
  padding: 0 12px 15px;
  border-top: 10px solid #f8f8f8;
  border-bottom: 10px solid #f8f8f8;
  min-height: 100%;

  .title {
    font-size: 16px;
    color: #333;
    font-weight: bold;
    padding-top: 15px;

    .num {
      font-size: 14px;
    }

    .arrow {
      float: right;
      padding-top: 5px;
    }
  }

  .commentList {
    background: #fff;
    padding: 10px 0 7px 10px;
    // margin: 0 12px;
    border-bottom: 1px solid #f2f2f2;
    position: relative;

    .commentAvatars {
      width: 34px;
      height: 34px;
      border-radius: 50%;
      display: inline-block;
      background-position: center center;
      background-repeat: no-repeat;
      background-size: cover;
      float: left;
    }

    .commentName {
      padding-left: 11px;
      color: #999;
      font-size: 14px;

      .myComment {
        background: #fff8f0;
        color: #d7ab3a;
        font-size: 12px;
        text-align: center;
        padding: 4px 7px;
        margin-left: 5px;
      }
    }

    .commentText {
      padding-top: 10px;
      padding-left: 10px;
      font-size: 14px;
      line-height: 22px;
      overflow: hidden;
      // max-height: 63px;
      color: #333;
      font-weight: 400;
      position: relative;
      word-wrap: break-word;
      word-break: break-all;
      text-overflow: ellipsis;

      .con {
        word-break: break-word;
        white-space: pre-wrap;
      }

      .expand {
        color: @color51;
        font-size: @fontSize14;
        line-height: 22px;
        display: none;
        position: absolute;
        bottom: 0;
        right: 5px;
        background: #fff;

        span {
          color: #8fa2f3;
        }
      }

      .closeCon {
        width: 100%;
        text-align: right;
        position: inherit;
      }
    }

    .bottom {
      padding-top: 10px;

      .time {
        color: #999;
        font-size: 11px;
        padding-left: 44px;

        .delete {
          color: #999;
          font-size: 11px;
          padding-left: 14px;
        }
      }

      //   .box {
      //     float: right;
      .commentLike {
        // float: right;
        // padding-right: 27px;
        position: absolute;
        right: 40px;
        display: inline-block;
        min-width: 60px;
        margin-right: 5px;

        .van-icon {
          font-size: 16px;
          margin-top: 1px;
          vertical-align: sub;
        }

        span {
          color: #999;
          display: inline-block;
          margin-left: 3px;
          vertical-align: bottom;
        }
      }

      .commentBox {
        position: absolute;
        right: 0px;
        // float: right;
        margin-right: 20px;

        img {
          width: 15px;
          height: 15px;
          vertical-align: text-bottom;
        }
      }

      //   }
    }

    .replyComments {
      margin: 10px 0 0 44px;
      background: #f8f8f8;
      border-radius: 8px;

      .replyCommentList {
        padding: 15px 0;
        margin: 0 16px;
        // border-bottom: 1px solid #EAEAEA;
        .replyCommentName {
          color: #666;
          font-size: 14px;

          img {
            width: 12px;
            height: 9px;
            padding: 0 6px;
          }
        }

        .replyCommentText {
          padding-top: 5px;
          color: #333;
          font-size: 12px;
          word-wrap: break-word;
          white-space: pre-wrap;
        }

        .replyBottom {
          padding-top: 10px;
          position: relative;

          .time {
            color: #999;
            font-size: 11px;

            .delete {
              color: #999;
              font-size: 11px;
              padding-left: 14px;
            }
          }

          //   .box {
          //     float: right;
          .commentLike {
            // padding-right: 27px;
            // float: right;
            position: absolute;
            right: 40px;
            top: 12px;
            display: inline-block;
            width: 48px;

            .van-icon {
              font-size: 12px;
              margin-top: 1px;
              vertical-align: text-top;
            }

            span {
              color: #999;
              display: inline-block;
              //   height: 20px;
              vertical-align: bottom;
              margin-left: 3px;
            }
          }

          .commentBox {
            // float: right;
            position: absolute;
            right: 5px;
            margin-right: 20px;

            img {
              width: 11px;
              height: 11px;
              vertical-align: text-bottom;
            }
          }
        }

        // }
      }

      .checkAllCom {
        color: #8a9ef3;
        font-size: 12px;
        margin: 10px 17px 10px 17px;
        border-top: 1px solid #eaeaea;
        height: 32px;
        line-height: 32px;

        .arrow {
          color: #8a9ef3;
          width: 5px;
          height: 9px;
          padding-left: 7px;
          padding-top: 2px;
          vertical-align: text-top;
        }
      }

      .border {
        padding-top: 10px;
        border-bottom: 1px solid #eaeaea;
      }
    }
  }

  .commentMore {
    text-align: center;
    height: 51px;
    line-height: 51px;

    span,
    i {
      font-size: @fontSize12;
      font-weight: 400;
      color: rgba(138, 158, 243, 1);
      line-height: 14px;
    }

    i {
      position: relative;
      top: 1.5px;
    }
  }

  .commentMore2 {
    display: none;
    text-align: center;
    height: 51px;
    line-height: 51px;

    span,
    i {
      font-size: @fontSize12;
      font-weight: 400;
      color: rgba(138, 158, 243, 1);
      line-height: 14px;
    }

    i {
      position: relative;
      top: 1.5px;
    }
  }
}

/**
* 发表评论
*/
#PublishComment {
  width: 100%;
  height: 58px;
  display: flex;
  position: fixed;
  bottom: 0;
  left: 0;
  background-color: #fff;
  z-index: 99999;
  box-shadow: 0px 0px 8px -1px rgba(0, 0, 0, 0.2);

  /deep/ .van-search__content {
    background-color: #fff8f0;
  }

  /deep/ .van-field__control::placeholder {
    color: #d7ab3a;
  }

  .speak {
    height: 34px;
    display: inline-block;
    margin-top: 2px;
    flex: 1 1 auto; //可放大 可缩小
  }

  .clickSave {
    float: right;
    text-align: center;
    margin-right: 16px;

    div {
      i {
        font-size: 16px;
        color: #999999;
        padding-top: 12px;
      }
    }

    figcaption {
      line-height: 12px;
      font-size: @fontSize12;
      color: #999999;
    }
  }

  .commentShare {
    float: right;
    text-align: center;
    margin-right: 16px;

    div {
      img {
        width: 12px;
        height: 12px;
        padding-top: 15px;
      }
    }

    figcaption {
      color: #999999;
      font-size: @fontSize12;
      line-height: 12px;
      margin-top: 1.8px;
    }
  }
}

/**
* 发送评论
*/
.centerComment {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: @expertColorMask;
  z-index: 1000;

  .mask {
    min-height: 70%;
  }

  .fieldWrap {
    background: rgba(255, 255, 255, 1);
    border-radius: 8px 8px 0 0;
    width: 100%;
    // height: 224px;
    position: fixed;
    bottom: 0;
    left: 0;

    .fieldTop {
      padding: 11px 0;
      // display: flex;
      // justify-content: space-between;
      overflow: hidden;

      .close {
        padding-left: 15px;
        padding-top: 5px;

        img {
          width: 12px;
          height: 12px;
        }
      }

      .title {
        text-align: center;
        color: #333;
        font-size: 16px;
        font-weight: 500;
        padding-left: 25px;
      }

      .button {
        width: 47px;
        height: 26px;
        background: #e2e2e2;
        border-radius: 4px;
        text-align: center;
        line-height: 26px;
        color: #a8a8a8;
        font-size: 12px;
        margin-right: 15px;
        float: right;
      }

      .button2 {
        background: linear-gradient(
          270deg,
          rgba(215, 168, 92, 1) 0%,
          rgba(231, 196, 121, 1) 100%
        );
        color: #fff;
      }
    }

    .fieldCon {
      padding: 15px 16px 0;

      /deep/ .input-item > div {
        width: 100%;
        font-size: @fontSize14;
        // min-height: 18px;
        margin-right: auto;
        line-height: 18px;
        color: #333333;
        word-wrap: break-word;
        // overflow-x: hidden;
        // overflow-y: auto;
        -webkit-user-select: text;
        outline: none;
        box-sizing: border-box;
        // max-height: 170px;
        padding: 0;
      }

      /deep/ .van-field__control {
        caret-color: #8489ff;
        // padding-top: 12px;
      }

      .input-item::-webkit-scrollbar {
        width: 0px;
      }

      .van-hairline--top-bottom::after {
        border: 0px;
      }
    }
  }
}

// #centerComment{
//     width:100%;
//     position: fixed;
//     bottom: 0;
//     left:0;
//     display: flex;
//     z-index: 99999;
//     overflow: hidden;
//     background-color: #fff;
//     align-items: center;
//     justify-content: center;
//     padding-bottom: 4px;
//     box-shadow:0px 0px 8px -1px rgba(0,0,0,0.2);
//     >div:nth-child(1){
//         >div::after{
//             border: none;
//         }
//         flex: 1 1 auto;
//         margin-top: 10px;
//         padding-bottom: 10px;
//         margin-left: 12px;
//         .input-item>div{
//             width: 100%;
//             font-size:@fontSize14;
//             min-height: 18px;
//             margin-right: auto;
//             line-height: 18px;
//             padding: 8px 4px 8px 4px;
//             color: #333333;
//             word-wrap: break-word;
//             overflow-x: hidden;
//             overflow-y: auto;
//             background:rgba(242,242,242,1);
//             border-radius:8px;
//             -webkit-user-select:text;
//             outline: none;
//             box-sizing: border-box;
//             max-height: 70px;
//         }
//         .input-item::-webkit-scrollbar {
//             width: 0px;
//         }
//     }
//     .SendOut{
//         font-size:16px;
//         font-weight:500;
//         color:rgba(215,171,58,1);
//         flex: 0 0 76px;
//         height: 100%;
//         text-align: center;
//         overflow-x: auto;
//         cursor: pointer;
//     }
// }
/**
* 页脚
*/
#footer {
  width: 100%;
  height: 47px;
  text-align: center;
  background: rgba(248, 248, 248, 1);
  line-height: 37px;
  border-bottom: 48px solid transparent;

  img {
    width: 154px;
    height: 16px;
  }
}

/**
* 视频加载中
*/
#videoLoading {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 999999;
  text-align: center;
  display: flex;

  img {
    margin: auto;
    width: 100px;
    justify-content: center;
  }
}
</style>

<script>
/**
 * 接口Api
 */
import API from '@/utils/axiosApi/harvardApi'
/**
 * 详情页视频播放组件
 */
import HFVideo from '@/components/activity/harvard/HFVideo'
/**
 * 所有视频
 */
import allVideo from '@/components/activity/harvard/allVideo.vue'
/**
 * 所有评论
 */
import allComment from '@/components/activity/harvard/allComment.vue'
/**
 * 专题列表
 */
import featuresCard from '@/components/activity/harvard/featuresCard.vue'
/**
 * 分享引导
 */
import HFshare from '@/components/contents/HFshare.vue'
/**
 * 关注引导
 */
import Follow from '@/components/contents/follow.vue'
/**
 * 所有医生数据
 */
import harvardData from './../../../utils/mockData/harvardData'
/**
 * getCookie 获取本地cookie插件
 */
import {
  Debounce,
  fomatterNum,
  getCookie,
  getHeadImgAndName,
  globalGoLogin,
  is_weixin,
  isFromMiniprogram,
  setCookie,
} from '@/assets/js/common.js'

// 引入哈佛视频微信分享公共方法
import hfwxJsSet from './../../../assets/js/HFwxConfig.js'
import commentField from '@/components/comment/commentField.vue'
// import allComment from "@/components/comment/allComment.vue";
export default {
  name: 'harvardDetail',
  data() {
    return {
      UserInfo: null, // localStorage中获取用户信息
      gread: null, //用户等级
      videoDetail: null, //视频详情信息
      videolike: {
        videolikes: null,
        isLike: null,
      }, //视频点赞数量
      doctorDetail: null, //医生详情信息
      Questions: null, //问答详情信息
      isTrue: false, //小黑板判断显不显示
      isBlacProgress: {
        queTrue: null,
        queFalse: null,
      }, //小黑板进度条样式
      AllComment: [], //所有评论
      upComment: [], // 展开评论
      upComShow: false,
      listLoading: false,
      listFinished: false,
      listError: false,
      finishText: '',
      commentParams: {
        page: 1,
        size: 25,
      },
      commentParams2: {
        page: 2,
        size: 25,
      },
      total: 0, //总评论数量
      currentTopicList: null, //当前专题列表
      topicList: [], //专题列表
      isFocus: false, //判断真是评论框是否展示
      allCommentFlag: true, //打开全部视频的时候是否显示输入评论框
      isFollowPublic: false, //是否展示关注公众号引导
      isGoLogin: false, //是否去登录 不去登录:false / 去登录:true
      userHeadImg: require('./../../../assets/images/Profile/profiledetails/avatar.png'), // 用户头像
      curVideoId: parseInt(this.$route.params.videoId), //当前视频的ID
      detailShow: true, //是否展开所有视频
      harvardData: harvardData.expertList, //所有的专家信息
      commentFirst: [], //所有评论
      userOpenid: '', //用户openid
      CRMID: JSON.parse(localStorage.getItem('userInfo'))
        ? JSON.parse(localStorage.getItem('userInfo')).crm_id
        : null, //当前用户的CRMID
      message: '', //评论内容
      oneConH: 22, //375屏幕下一行评论的高度
      firstFlag: false, //以及评论点赞开关
      secondFlag: false, //二级评论点赞开关
      sendSWitch: true, //防止评论重复发送
      videoLoadings: false, //视频加载中
      preventFlag: false, //是否打开了全部评论或者全部视频
      noNickName: null, //没有用户昵称
      carrierId: '1', // 1 哈佛 2 奶娃百科
      currentTop: '',
      commentType: '',
      replyUserInfo: [], // 回复用户信息
      replyNames: '',
      scrollWatch: true,
      scrollTop: '',
    }
  },
  /**
   * @description: 导航守卫，进入页面之前执行
   * @param {type}
   * @return:
   */
  beforeRouteLeave(to, from, next) {
    if (to.name == 'harvardIndex') {
      this.$store.commit('changeIncludes', ['harvardIndex', 'home'])
    }
    next()
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.$store.commit('changeIncludes', [
        'harvardIndex',
        'harvardDetail',
        'home',
        'expertsViewIndex',
        'expertsViewList',
      ])
      if (vm.is_weixin()) {
        //微信中
        if (
          vm.getCookie('xmh_openid') == null ||
          vm.getCookie('xmh_openid') == ''
        ) {
          //判断有没有openId
          location.href =
            '/xmh/v2/wechat/oauth2/authorize?url=' +
            encodeURIComponent(window.location.href)
        } else {
          // 有openid获取用户信息
          vm.userOpenid = vm.getCookie('xmh_openid')
          vm.getUserName()
          const fn_video_id = Number(location.pathname.replace(/[^0-9]/gi, '')) //当前视频的id
          if (vm.$route.query.shareFrom == 'wxHfShare') {
            // 是否关注了星妈会
            vm.isFollow(() => {
              API.newUser(
                {},
                {
                  openId: vm.userOpenid,
                  fnVideoId: fn_video_id,
                }
              )
            })
          } else {
            vm.isFollow()
          }
          // 每次进入页面都需要重新获取用户信息,如果有用户信息不需要重新获取
          if (!JSON.parse(localStorage.getItem('userInfo'))) {
            API.goLogin({}, { openId: vm.userOpenid }, (res) => {
              if (res.code == '200') {
                // 赋值用户信息
                vm.UserInfo = res.data
                // 赋值CRMID信息
                vm.CRMID = res.data.crm_id
                localStorage.setItem('userInfo', JSON.stringify(res.data))
                sensors.login(res.data.crm_id)
                // 判断老用户是否注册，没注册需要去注册。
                if (!res.data.mobile) {
                  //未登录
                  vm.isGoLogin = true
                }
                // 初始化方法
                vm.initHFVideo()
              } else {
                // 判断本地是否有用户信息
                vm.isGoLogin = true
                // 初始化方法
                vm.initHFVideo()
              }
            })
          } else {
            // 从本地取用户信息
            vm.UserInfo = JSON.parse(localStorage.getItem('userInfo'))
            sensors.login(vm.UserInfo.crm_id)
            vm.CRMID = vm.UserInfo.crm_id
            // 判断老用户是否注册，没注册需要去注册。
            if (!vm.UserInfo.mobile) {
              //未登录
              vm.isGoLogin = true
            }
            // 初始化方法
            vm.initHFVideo()
          }
        }
      } else {
        // 从本地取用户信息
        vm.UserInfo = JSON.parse(localStorage.getItem('userInfo'))
        if (
          vm.getCookie('xmh_phone') == null ||
          vm.getCookie('xmh_phone') == '' ||
          vm.UserInfo == null ||
          vm.UserInfo == ''
        ) {
          //未登录
          vm.isGoLogin = true
        }
        vm.getUserName()
        // 获取用户头像
        // if (getCookie("xmh_headimgurl")) {
        //   vm.userHeadImg = getCookie("xmh_headimgurl");
        // }
        // if ((!vm.getCookie("xmh_nickname") || vm.getCookie("xmh_nickname") == "") || (!vm.getCookie("xmh_headimgurl") || vm.getCookie("xmh_headimgurl") == "")) {
        //   vm.$http.get("/wechat/getUserInfoByOpenId", { openId: vm.getCookie("xmh_openid") }, res => {
        //     if (res.code === "200") {
        //       // document.cookie = `xmh_headimgurl=${res.data.headimgurl}`;
        //       // document.cookie = 'xmh_nickname=' + escape(res.data.nickname);
        //       vm.setCookie('xmh_headimgurl', res.data.headimgurl, 365)
        //       vm.setCookie('xmh_nickname', res.data.nickname, 365)
        //     }
        //   });
        // }
        // 初始化方法
        vm.initHFVideo()
      }
    })
  },
  beforeRouteLeave(to, from, next) {
    this.scrollWatch = false
    window.removeEventListener('scroll', this.handleScroll)
    next()
  },
  watch: {
    curVideoId(newValue, oldValue) {
      this.initHFVideo()
    },
    scrollTop: {
      handler() {
        this.handleScroll()
      },
    },
    '$route.query': {
      handler(newValue) {
        console.log(newValue, 'pageSource123123')
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    // 判断是否来自小程序环境
    checkFromMiniprogram() {
      return isFromMiniprogram(this.$route)
    }
  },
  beforeDestroy() {
    this.scrollWatch = false
    window.removeEventListener('scroll', this.handleScroll)
  },
  mounted() {
    if (this.scrollWatch) {
      window.addEventListener('scroll', this.handleScroll)
    }
  },
  methods: {
    getUserName: async function () {
      try {
        const { headImgurl, nickName } = await getHeadImgAndName()
        this.setCookie('xmh_headimgurl', headImgurl, 365)
        this.setCookie('xmh_nickname', nickName, 365)
        this.userHeadImg = headImgurl
      } catch (err) {}
    },
    handleScroll() {
      this.scroll =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      let top1 = $('.wrap').offset().top
      let top2 = $(document).scrollTop()
      let height = document.getElementsByClassName('gobackBtn')[0].clientHeight
      // let top = top1 - top2;
      if (this.scroll > height && this.scroll > top1) {
        let t1 = 0
        let t2 = 0
        let timer2 = null // 定时器
        document.onscroll = function () {
          clearTimeout(timer2)
          timer2 = setTimeout(isScrollEnd, 300)
          t1 = document.documentElement.scrollTop || document.body.scrollTop
        }

        function isScrollEnd() {
          t2 = document.documentElement.scrollTop || document.body.scrollTop
          var path
          if (t2 == t1) {
            path = require('./../../../assets/images/icon/back1.png')
            $('.backimg').attr('src', path)
          } else {
            path = require('./../../../assets/images/icon/back2.png')
            $('.backimg').attr('src', path)
          }
        }

        $('.gobackBtn2').css({ display: 'inline-block' })
      } else {
        $('.gobackBtn2').css('display', 'none')
      }
    },
    // 跳转二级回复页
    toReplyCom(item) {
      // type类型 1 哈佛 2 奶娃百科 this.carrierId
      // 文章或视频id  this.articalId
      // 一级评论id item.id
      this.$router.push({
        path: '/replyComment',
        query: {
          type: this.carrierId,
          carrierSpecificId: this.curVideoId,
          first: item.id,
        },
      })
    },
    // 删除评论弹窗
    dialogToast(item, type) {
      const fn_video_id = Number(location.pathname.replace(/[^0-9]/gi, '')) //当前视频的id
      let delete_comment_type
      type == 1
        ? (delete_comment_type = '评论')
        : (delete_comment_type = '回复')
      sensors.track('DeleteComment', {
        content_id: fn_video_id,
        content_title: this.title,
        content_topic: this.currentTopicList.topicTitle,
        page_name: this.$route.meta.title,
        delete_comment_type,
      })
      this.$dialog
        .confirm({
          message: '是否删除评论',
          confirmButtonText: '确定',
        })
        .then(() => {
          this.deleteCom(item, type)
        })
        .catch(() => {})
    },
    // 删除评论
    deleteCom: function (item, type) {
      this.$http.get(
        this.$http.harvardBaseURL + '/comment/deleteComment/ZBvOm0ocQSUykUX5',
        {
          id: item.id,
          crmId: this.UserInfo.crm_id,
          type: type,
        },
        (res) => {
          if (res.code == '200') {
            this.$toast({
              duration: 2000,
              message: '删除评论成功',
              context: this,
            })
            this.getAllComment()
          }
        }
      )
    },
    // 二级回复提交
    secondSubmitAllComment: Debounce(function () {
      this.isFocus = false
      const fn_video_id = Number(location.pathname.replace(/[^0-9]/gi, '')) //当前视频的id
      sensors.track('CommentReplySent', {
        content_id: fn_video_id,
        content_title: this.title,
        content_topic: this.currentTopicList.topicTitle,
        page_name: this.$route.meta.title,
      })
      this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
      let headImg = this.getCookie('xmh_headimgurl')
      let nickName = this.getCookie('xmh_nickname')
      let openid = this.getCookie('xmh_openid')
      let date = Date.parse(new Date())
      let appkey = '10002'
      let appSecret = 'HDKumsH47xXUAymRkPgLQt9qL9Odjljk'
      let sign = this.$md5(
        appSecret +
          'timestamp' +
          date +
          'crmId' +
          this.userInfo.crm_id +
          appSecret
      ).toUpperCase()
      this.$http.post(
        this.$http.harvardBaseURL +
          '/comment/save/reply/ZBvOm0ocQSUykUX5?sign=' +
          sign +
          '&timestamp=' +
          date,
        {},
        {
          carrierId: this.carrierId,
          carrierSpecificId: this.curVideoId,
          contents: this.message,
          crmId: this.userInfo.crm_id,
          headImg: headImg,
          nickName: nickName,
          replyCrmId: this.replyUserInfo.crmId,
          replyNickName: this.replyUserInfo.nickName,
          replyHeadImg: this.replyUserInfo.headImg,
          commentType: this.commentType,
          commentId: this.replyUserInfo.id,
          parentId:
            this.commentType == '1'
              ? this.replyUserInfo.id
              : this.replyUserInfo.parentId,
          openid: openid,
          replyOpenId: this.replyUserInfo.openid,
        },
        (res) => {
          if (res.code == '200') {
            this.message = ''
            $('body').css('position', 'initial')
            $('body').css('overflow', '')
            $('.button').removeClass('button2')
            this.$toast({
              duration: 3000,
              message: '评论成功',
              context: this
            });
            this.getAllComment()
          } else {
            this.$toast({
              duration: 2000,
              message: res.message,
              context: this,
            })
          }
        }
      )
    }, 500),
    inputChange() {
      if (this.message.length >= 1) {
        $('.button').addClass('button2')
      } else if (this.message.length == 0) {
        $('.button').removeClass('button2')
      }
    },
    replyComment: function (item, type) {
      if (this.isGoLogin) {
        this.isLogin()
      } else {
        // if(type=='first'){ // 一级回复
        //     this.replyNames=item.nickName
        // }else{ // 二级回复
        //     this.replyNames=item.replyNickName
        // }
        $('body').css('position', 'absolute')
        $('body').css('overflow', '')
        this.commentType = type
        this.replyNames = item.nickName
        this.replyUserInfo = item
        this.isFocus = true
        console.log($('textarea'))
        this.$nextTick(() => {
          $('textarea')[1].focus()
        })
      }
    },
    isBlur(id) {
      if (id == '1') {
        this.isFocus = false
      } else if (id == '2') {
      } else if (id == '3') {
      }
    },
    /**
     * @description: 是否去登录
     * @param {type}
     * @return:
     */
    isLogin() {
      if (this.isGoLogin) {
        // this.$router.push({ path: "/phoneLogin?redirect=" + window.location.href });
        globalGoLogin()
        var gradeName = this.gread ? this.gread.grade.name : '未登录'
      }
    },
    /**
     * @description: 返回上一页
     * @param {type}
     * @return:
     */
    goBack() {
      var pageSource = 'class'
      if (this.$route.query.pageSource)
        pageSource = this.$route.query.pageSource
      if (
        window.history.length > 1 &&
        this.getCookie('fromPath') &&
        !sessionStorage.getItem('playPop')
      ) {
        this.$router.back(-1)
      } else {
        this.$router.push({
          path:
            '/harvard?pageSource=' +
            pageSource +
            '&source=' +
            this.$route.query.source,
        })
        sessionStorage.removeItem('playPop')
      }
      // this.$router.push({path:'/harvard'});
      // 清除上次监听视频播放的时间
      if ($('video')) {
        $('video').off('timeupdate')
      }
    },
    /**
     * @description: 初始化详情界面信息
     * @param {type}
     * @return:
     */
    async initHFVideo() {
      // 没有登录不调用获取等级的方法
      if (!this.isGoLogin) {
        // 获取等级
        await this.getUserGread()
      }
      // 获取视频详情
      await this.getVideoDetail()
      // 获取视频专题列表
      await this.getTopicsList()
      // 切换视频重新设置分享信息
      await this.shaCurrentVideo()
      // 获取问答详情信息
      await this.getQuestions()
      // 获取所有评论
      await this.getAllComment()
    },
    /**
     * @description: 获取用户等级
     * @param {type} crmId 用户等级id
     * @return: gread 用户等级
     */
    getUserGread() {
      return new Promise((resolve, reject) => {
        API.getUserGrade({}, { crmId: this.CRMID }, (res) => {
          if (res.code == '200') {
            this.gread = res.data
            resolve(res.data)
          }
        })
      })
    },
    /**
     * @description: 获取视频详情
     * @param {type} crm_id 用户id grade 用户等级 fn_video_id 视频id
     * @return: videoDetail 视频详情数据
     */
    getVideoDetail() {
      let self = this
      const code = this.gread != null ? this.gread.grade.code : 0
      const fn_video_id = Number(location.pathname.replace(/[^0-9]/gi, '')) //当前视频的id
      return new Promise((resolve, reject) => {
        API.getVideoDetail(
          {},
          { crm_id: this.CRMID, grade: code, fn_video_id: fn_video_id },
          (res) => {
            if (res.code == '200') {
              this.videoDetail = res.data
              // 为了阻止视频组件监听的 videoDetail 重新渲染所，以给视频点赞单独加变量。
              this.videolike.videolikes = res.data.likes
              this.videolike.isLike = res.data.isLike
              this.getDoctorDetail()
              resolve(res.data)
            }
          }
        )
      })
    },
    /**
     * @description: 获取正在播放视频医生信息
     * @param {type} expertId 专家id
     * @return: 当前播放视频讲师详情信息
     */
    getDoctorDetail() {
      this.harvardData.forEach((item) => {
        if (item.id == this.videoDetail.expertId) {
          this.doctorDetail = item
        }
      })
    },
    /**
     * @description: 获取视频专题列表
     * @param {type} null
     * @return: topicList 视频专题
     */
    getTopicsList() {
      let self = this
      // 获取专题列表首先要清空上次预留的专题列表
      self.topicList = []
      return new Promise((resolve, reject) => {
        API.getAllTopicVideo({}, (res) => {
          if (res.code == '200') {
            const topic = res.data
            const topicid = this.videoDetail.topicId //当前播放视频的 topicid
            topic.forEach(function (item) {
              if (item.topicId == topicid) {
                // 正在播放的视频列表
                self.currentTopicList = item
              } else {
                // 判断当前视频详情有没有，有专题没视频则不展示。
                if (item.harvardVideos && item.harvardVideos.length != 0) {
                  self.topicList.push(item)
                }
              }
            })
            localStorage.setItem("hfVideo", JSON.stringify(res.data))
            resolve(res.data)
          }
        })
      })
    },
    /**
     * @description: 查看所有视频
     * @param {type}
     * @return:
     */
    openAllVideo(obj) {
      this.detailShow = false
      this.allCommentFlag = false
      this.preventFlag = true
      this.$refs.allVideo.openAllVideo(obj)
    },
    /**
     * @description: 关闭查看所有视频
     * @param {type}
     * @return:
     */
    closeAllVideo() {
      this.allCommentFlag = true
      this.detailShow = true
      this.preventFlag = false
    },
    /**
     * @description: 点击播放当前视频
     * @param {type}
     * @return:
     */
    playCurVideo(curVideoId, type) {
      this.curVideoId = curVideoId
      const fn_video_id = Number(location.pathname.replace(/[^0-9]/gi, '')) //当前视频的id
      var pageSource = this.$route.query.pageSource || 'class'
      history.replaceState(
        null,
        '哈佛育儿课堂',
        '/harvard/' +
          this.curVideoId +
          '?pageSource=' +
          pageSource +
          '&source=' +
          this.$route.query.source
      )
      this.videoLoadings = this.curVideoId != fn_video_id
      if ($('video').length > 0 && this.curVideoId != fn_video_id) {
        this.$refs.HFVideo.Player.pause()
        $('video').css('display', 'none')
        $('.xgplayer-controls').css('opacity', '0')
      }
      let gradeName = this.gread ? this.gread.grade.name : '未登录'
      if (type && type != '') {
        if (type == 1) {
          //专题内切换视频
          sessionStorage.setItem('playPop', true)
        } else {
          //推荐视频切换
        }
      }
    },
    /**
     * @description: 获取文答详情信息
     * @param {type} crmid 用户id fnVideoId 视频ID topicId 专题ID
     * @return: Questions 问答详情信息
     */
    getQuestions() {
      const { fnVideoId, topicId } = this.videoDetail //当前视频的id
      return new Promise((resolve, reject) => {
        API.getQuestions(
          { crm_id: this.CRMID, video_id: fnVideoId, v_id: topicId },
          (res) => {
            if (res.code == '200') {
              this.Questions = res.data
              resolve()
              if (res.data.userAnswers) {
                const { correctNum, errorNum } = res.data
                this.isBlacProgress.queTrue =
                  parseInt(255 * (correctNum / 100)) / 37.5
                this.isBlacProgress.queFalse =
                  parseInt(255 * (errorNum / 100)) / 37.5
                this.isTrue = true
              } else {
                this.isTrue = false
              }
            }
          }
        )
      })
    },
    /**
     * @description: 问答正确按钮
     * @param {type} 答案参数
     * @return: @return: null
     */
    btnTrue() {
      if (this.isGoLogin) {
        this.isLogin()
      } else {
        const { answers, id: videoId, correctNum, errorNum } = this.Questions
        // 把用户选择的数据给后台
        API.saveQuestions({}, { "answers": true, "quesId": videoId, "crmId": this.CRMID }, res => {
          if (res.code == 200) {
            this.isBlacProgress.queTrue = parseInt(255 * (correctNum / 100)) / 37.5;
            this.isBlacProgress.queFalse = parseInt(255 * (errorNum / 100)) / 37.5;
            // 关闭问答按钮
            this.isTrue = true;
            if (answers == true) {
              this.$toast({
                duration: 3000,
                message: '恭喜您，回答正确咯～\n',
                context: this
              });
            } else {
              this.$toast({
                duration: 3000,
                message: '哎呀，答错了 \n 快看看其他妈妈怎么说\n',
                context: this
              });
            }
          }
        });

      }
    },
    /**
     * @description: 问答错误按钮
     * @param {type} 答案参数
     * @return: null
     */
    btnFalse() {
      if (this.isGoLogin) {
        this.isLogin()
      } else {
        const { answers, id: videoId, correctNum, errorNum } = this.Questions
        // 把用户选择的数据给后台
        API.saveQuestions({}, { "answers": false, "quesId": videoId, "crmId": this.CRMID }, res => {
          if (res.code == 200) {
            this.isBlacProgress.queTrue = parseInt(255 * (correctNum / 100)) / 37.5;
            this.isBlacProgress.queFalse = parseInt(255 * (errorNum / 100)) / 37.5;
            // 显示进度条
            this.isTrue = true;
            if (answers == false) {
              this.$toast({
                duration: 3000,
                message: '恭喜您，回答正确咯～\n',
                context: this
              });
            } else {
              this.$toast({
                duration: 3000,
                message: '哎呀，答错了 \n 快看看其他妈妈怎么说\n',
                context: this
              });
            }
          }
        })
      }
    },
    /**
     * @description:获取所有评论
     * @param {type}
     * @return:
     */
    getAllComment(commentStatus) {
      const fn_video_id = Number(location.pathname.replace(/[^0-9]/gi, '')) //当前视频的id
      return new Promise((resolve, reject) => {
        API.getComments(
          {},
          {
            page: 1,
            size: 25,
            data: {
              carrierId: 1,
              crmId: this.CRMID,
              carrierSpecificId: fn_video_id,
            },
          },
          (res) => {
            if (res.code == 200) {
              /**
               * 关闭加载
               * */
              if (!commentStatus) {
                setTimeout(() => {
                  this.videoLoadings = false
                  if ($('video').length > 0) {
                    //弹出层出来的时候不自动播放
                    if (!this.$refs.HFshareVideo.$data.shareWxFlagVideo) {
                      this.$refs.HFVideo.Player.play()
                    }
                    $('#HF').css('background-image', '')
                    $('video').css('display', 'block')
                    $('.xgplayer-controls').css('opacity', '1')
                  }
                }, 1500)
              }

              if (res.data.list.length > 0) {
                const { list, total } = res.data
                this.commentFirst = res.data
                this.AllComment = list.slice(0, 3)
                this.upComment = list.slice(3)
                this.total = total
                setTimeout(() => {
                  this.currentTop = $('.commentWrap').offset().top
                }, 500)
              } else {
                this.AllComment = []
                this.upComment = []
                this.total = 0
                this.commentFirst = res.data
              }
              /**
               * 初始化评论展开隐藏
               * */
              let comInput = (58 * (window.innerWidth / 10)) / 37.5
              if ($('#PublishComment')[0]) {
                comInput = $('#PublishComment')[0].clientHeight
              }
              $('.commentAll').css({
                height:
                  $(document.body).height() -
                  $('#HFVideo')[0].clientHeight -
                  comInput +
                  'px',
                'padding-bottom': comInput + 'px',
              })
              this.$nextTick(() => {
                this.oneConH =
                  parseInt($('.commentText').css('line-height')) * 3
                var that = this
                $.each(this.$refs.commentList, function (index, item) {
                  let conH = $(item).find('.con')[0].offsetHeight
                  if (conH > that.oneConH) {
                    $(item).find('.openCon').css('display', 'block')
                  }
                })
              })
              resolve(res.data)
            } else {
              /**
               * 关闭加载
               * */
              if (!commentStatus) {
                setTimeout(() => {
                  this.videoLoadings = false
                  if ($('video').length > 0) {
                    //弹出层出来的时候不自动播放
                    if (!this.$refs.HFshareVideo.$data.shareWxFlagVideo) {
                      this.$refs.HFVideo.Player.play()
                    }
                    $('#HF').css('background-image', '')
                    $('video').css('display', 'block')
                    $('.xgplayer-controls').css('opacity', '1')
                  }
                }, 1500)
              }
            }
          }
        )
      })
    },
    // 展开加载评论
    getUpAllComment: function (curVideoId) {
      if (this.upComment.length >= '22') {
        const { page, size } = this.commentParams2
        // var page = status==true?page:this.commentParams.page
        // var size = status==true?size:this.commentParams.size
        API.getComments(
          {},
          {
            page,
            size,
            data: {
              carrierId: 1,
              crmId: this.UserInfo != null ? this.UserInfo.crm_id : '',
              carrierSpecificId: curVideoId,
            },
          },
          (res) => {
            this.listLoading = false
            if (res.code == '200') {
              const { list, total } = res.data
              if (total == '25') {
                this.listFinished = true
                this.finishText = '——已经到底了哦——'
              } else {
                this.upComment = this.upComment.concat(list)
                this.$nextTick(() => {
                  if (this.upComment.length > 0) {
                    let commentLists = this.$refs.commentList.slice(
                        this.commentLen,
                        this.$refs.commentList.length
                      ),
                      that = this
                    $.each(commentLists, function (index, item) {
                      let conH = $(item).find('.con')[0].offsetHeight
                      if (conH > that.oneConH) {
                        $(item).find('.openCon').css('display', 'block')
                      }
                    })
                    this.commentLen = this.$refs.commentList.length - 1
                  }
                })
                if (
                  page >= Math.ceil(total / size) ||
                  Math.ceil(total / size) <= 1
                ) {
                  this.listFinished = true
                  this.finishText = '——已经到底了哦——'
                } else {
                  this.listFinished = false
                  this.commentParams2.page += 1
                }
              }
            } else {
              this.listLoading = false
              this.listError = true
            }
          }
        )
      } else {
        this.listLoading = false
        this.listFinished = true
        this.finishText = '——已经到底了哦——'
      }
    },
    /**
     * @description: 一级评论点赞与取消点赞 upComment
     * @param {type}
     * @return:
     */
    support(index, type, parentId, replyCrmId, commentId, ComType) {
      if (this.isGoLogin) {
        this.isLogin()
      } else {
        if (this.firstFlag) return false
        this.firstFlag = true
        const { isLikes, likes, id } = this.AllComment[index]
        let self = this
        const fn_video_id = Number(location.pathname.replace(/[^0-9]/gi, ''))
        const time =
          this.videoDetail.videoDuration.split(':')[0] * 60 +
          this.videoDetail.videoDuration.split(':')[1] * 1 -
          1
        if (isLikes) {
          sensors.track('Unsupport', {
            content_id: fn_video_id,
            content_title: this.videoDetail.videoTitle,
            author: '',
            length_of_time: time,
            content_topic: this.currentTopicList.topicTitle,
            page_name: this.$route.meta.title,
            is_comment: true,
          })
          this.cancelLike(2, parentId, replyCrmId, commentId, function () {
            self.firstFlag = false
            self.AllComment[index].likes -= 1
            if (likes < 0) {
              self.AllComment[index].likes = 0
            }
            self.AllComment[index].isLikes = !isLikes
          })
        } else {
          const time =
            this.videoDetail.videoDuration.split(':')[0] * 60 +
            this.videoDetail.videoDuration.split(':')[1] * 1 -
            1
          sensors.track('Support', {
            content_id: fn_video_id,
            content_title: this.videoDetail.videoTitle,
            author: '',
            length_of_time: time,
            content_topic: this.currentTopicList.topicTitle,
            page_name: this.$route.meta.title,
            is_comment: true,
          })
          this.addLike(id, 2, parentId, replyCrmId, commentId, function () {
            self.firstFlag = false
            self.AllComment[index].likes += 1
            self.AllComment[index].isLikes = !isLikes
          })
        }
      }
    },
    /**
     * @description: 二级评论点赞与取消点赞
     * @param {type}
     * @return:
     */
    secondSupport(index, num, type, parentId, replyCrmId, commentId, ComType) {
      if (this.isGoLogin) {
        this.isLogin()
      } else {
        if (this.secondFlag) return false
        this.secondFlag = true
        const { isLikes, likes, id } =
          this.AllComment[index].pageBean.content[num]
        const fn_video_id = Number(location.pathname.replace(/[^0-9]/gi, ''))
        const time =
          this.videoDetail.videoDuration.split(':')[0] * 60 +
          this.videoDetail.videoDuration.split(':')[1] * 1 -
          1
        let self = this
        if (isLikes) {
          //取消点赞
          sensors.track('Unsupport', {
            content_id: fn_video_id,
            content_title: this.videoDetail.videoTitle,
            author: '',
            length_of_time: time,
            content_topic: this.currentTopicList.topicTitle,
            page_name: this.$route.meta.title,
            is_comment: true,
          })
          this.secondCancelLike(
            num,
            3,
            parentId,
            replyCrmId,
            commentId,
            function () {
              self.secondFlag = false
              self.AllComment[index].pageBean.content[num].likes -= 1
              if (likes < 0) {
                self.AllComment[index].pageBean.content[num].likes = 0
              }
              self.AllComment[index].pageBean.content[num].isLikes = !isLikes
            }
          )
        } else {
          sensors.track('Support', {
            content_id: fn_video_id,
            content_title: this.videoDetail.videoTitle,
            author: '',
            length_of_time: time,
            content_topic: this.currentTopicList.topicTitle,
            page_name: this.$route.meta.title,
            is_comment: true,
          })

          this.secondAddLike(
            num,
            3,
            parentId,
            replyCrmId,
            commentId,
            function () {
              self.secondFlag = false
              self.AllComment[index].pageBean.content[num].likes += 1
              self.AllComment[index].pageBean.content[num].isLikes = !isLikes
            }
          )
        }
      }
    },
    //展开一级评论点赞与取消点赞
    upSupport(index, type, parentId, replyCrmId, commentId) {
      if (this.isGoLogin) {
        this.isLogin()
      } else {
        if (this.firstFlag) return false
        this.firstFlag = true
        const { isLikes, likes, id } = this.upComment[index]
        let self = this
        if (isLikes) {
          this.cancelLike(2, parentId, replyCrmId, commentId, function () {
            self.firstFlag = false
            self.upComment[index].likes -= 1
            if (likes < 0) {
              self.upComment[index].likes = 0
            }
            self.upComment[index].isLikes = !isLikes
          })
        } else {

          this.addLike(id, 2, parentId, replyCrmId, commentId, function () {
            self.firstFlag = false
            self.upComment[index].likes += 1
            self.upComment[index].isLikes = !isLikes
          })
        }
      }
    },
    //二级评论点赞与取消点赞
    upSecondSupport(index, num, type, parentId, replyCrmId, commentId) {
      if (this.isGoLogin) {
        this.isLogin()
      } else {
        if (this.secondFlag) return false
        this.secondFlag = true
        const { isLikes, likes, id } =
          this.upComment[index].pageBean.content[num]
        let self = this

        if (isLikes) {
          this.secondCancelLike(
            num,
            3,
            parentId,
            replyCrmId,
            commentId,
            function () {
              self.secondFlag = false
              self.upComment[index].pageBean.content[num].likes -= 1
              if (likes < 0) {
                self.upComment[index].pageBean.content[num].likes = 0
              }
              self.upComment[index].pageBean.content[num].isLikes = !isLikes
            }
          )
        } else {
          this.secondAddLike(
            num,
            3,
            parentId,
            replyCrmId,
            commentId,
            function () {
              self.secondFlag = false
              self.upComment[index].pageBean.content[num].likes += 1
              self.upComment[index].pageBean.content[num].isLikes = !isLikes
            }
          )
        }
      }
    },
    /**
     * @description: 一级点赞请求
     * @param {type}
     * @return:
     */
    addLike (id, type, parentId, replyCrmId, commentId, callback) {
      var nickName = this.getCookie('xmh_nickname');
      var headImg = this.getCookie('xmh_headimgurl');
      API.addLikes({}, {
        carrierId: 1,
        carrierSpecificId: this.curVideoId,
        crmId: this.UserInfo.crm_id,
        sourceId: 4,
        type: type,
        isRead: false,
        parentId: parentId,
        status: true,
        nickName: nickName,
        headImg: headImg,
        replyCrmId: replyCrmId,
        commentId: commentId,
      }, res => {
        if (res.code == "200") {
          this.$toast({
            duration: 3000,
            message: '点赞成功',
            context: this
          });
          callback();
        }
      })
    },
    /**
     * @description: 一级取消点赞请求
     * @param {type}
     * @return:
     */
    cancelLike(type, parentId, replyCrmId, commentId, callback) {
      API.cancelLikes(
        {},
        {
          carrierId: 1,
          carrierSpecificId: this.curVideoId,
          crmId: this.UserInfo.crm_id,
          sourceId: 4,
          type: type,
          isRead: false,
          parentId: parentId,
          status: true,
          replyCrmId: replyCrmId,
          commentId: commentId,
        },
        (res) => {
          if (res.code == '200') {
            callback()
          }
        }
      )
    },

    // 二级点赞
    secondAddLike (num, type, parentId, replyCrmId, commentId, callback) {
      var nickName = this.getCookie('xmh_nickname');
      var headImg = this.getCookie('xmh_headimgurl');
      API.addLikes({}, {
        carrierId: 1,
        carrierSpecificId: this.curVideoId,
        crmId: this.UserInfo.crm_id,
        sourceId: 4,
        type: type,
        isRead: false,
        parentId: parentId,
        status: true,
        nickName: nickName,
        headImg: headImg,
        replyCrmId: replyCrmId,
        commentId: commentId,
      }, res => {
        if (res.code == "200") {
          this.$toast({
            duration: 3000,
            message: '点赞成功',
            context: this
          });
          callback();
        }
      })
    },
    // 二级取消点赞
    secondCancelLike(num, type, parentId, replyCrmId, commentId, callback) {
      API.cancelLikes(
        {},
        {
          carrierId: 1,
          carrierSpecificId: this.curVideoId,
          crmId: this.UserInfo.crm_id,
          sourceId: 4,
          type: type,
          isRead: false,
          parentId: parentId,
          status: true,
          replyCrmId: replyCrmId,
          commentId: commentId,
        },
        (res) => {
          if (res.code == '200') {
            callback()
          }
        }
      )
    },
    /**
     * @description: 点击展开评论
     * @param {type}
     * @return:
     */
    expandComment(event, handleType) {
      const fn_video_id = Number(location.pathname.replace(/[^0-9]/gi, ''))
      let act_type
      handleType === 1 ? (act_type = '展开') : (act_type = '收起')
      const time =
        this.videoDetail.videoDuration.split(':')[0] * 60 +
        this.videoDetail.videoDuration.split(':')[1] * 1 -
        1
      sensors.track('CommentAct', {
        content_id: fn_video_id,
        content_title: this.videoDetail.videoTitle,
        author: '',
        length_of_time: time,
        content_topic: this.currentTopicList.topicTitle,
        page_name: this.$route.meta.title,
        act_type,
      })

      this.oneConH = parseInt($('.commentText').css('line-height')) * 3
      if (handleType == 1) {
        //展开
        $(event.target).parents('.commentText').css('max-height', 'initial')
        $(event.target)
          .parents('.commentText')
          .find('.openCon')
          .css('display', 'none')
        $(event.target)
          .parents('.commentText')
          .find('.closeCon')
          .css('display', 'block')
      } else {
        //收起
        $(event.target)
          .parents('.commentText')
          .css('max-height', this.oneConH + 'px')
        $(event.target)
          .parents('.commentText')
          .find('.openCon')
          .css('display', 'block')
        $(event.target)
          .parents('.commentText')
          .find('.closeCon')
          .css('display', 'none')
      }
    },
    /**
     * @description: 判断内容展示隐藏
     * @param {type}
     * @return:
     */
    returnContent(content) {
      return content.length > 63 ? content.slice(0, 63) + '...' : content
    },
    /**
     * @description: 查看所有评论
     * @param {type}
     * @return:
     */
    openAllComment(type) {
      if (type === '3') {
        const time =
          this.videoDetail.videoDuration.split(':')[0] * 60 +
          this.videoDetail.videoDuration.split(':')[1] * 1 -
          1
        const fn_video_id = Number(location.pathname.replace(/[^0-9]/gi, '')) //当前视频的id
        sensors.track('ExpandAll', {
          content_id: fn_video_id,
          content_title: this.videoDetail.videoTitle,
          author: '',
          length_of_time: time,
          content_topic: this.currentTopicList.topicTitle,
          page_name: this.$route.meta.title,
        })
      }
      if (type == '1' || type == '3') {
        this.upComShow = true
        $('.commentMore').css('display', 'none')
        $('.commentMore2').css('display', 'block')
        this.$nextTick(() => {
          this.oneConH = parseInt($('.commentText').css('line-height')) * 3
          var that = this
          $.each(this.$refs.commentList, function (index, item) {
            let conH = $(item).find('.con')[0].offsetHeight
            if (conH > that.oneConH) {
              $(item).find('.openCon').css('display', 'block')
            }
          })
        })
      } else {
        this.upComShow = false
        $('.commentMore').css('display', 'block')
        $('.commentMore2').css('display', 'none')
      }

    },
    /**
     * @description: 关闭查看所有评论弹窗
     * @param {type}
     * @return:
     */
    closeComment() {
      this.detailShow = true
      this.preventFlag = false
    },
    /**
     * @description: 提交评论
     * @param {type}
     * @return:
     */
    submitAllComment() {
      this.isFocus = false
      if (this.isGoLogin) {
        this.isLogin()
        this.message = ''
      } else {
        if (this.sendSWitch) {
          this.sendSWitch = false
          const fn_video_id = Number(location.pathname.replace(/[^0-9]/gi, '')) //当前视频的id
          if (this.message) {
            if (this.getCookie('xmh_nickname')) {
              this.noNickName = this.getCookie('xmh_nickname')
            } else {
              let iphoneNumber = String(this.UserInfo.mobile)
              this.noNickName = '微信用户' + iphoneNumber.substr(7, 11)
            }
            API.submitComments({}, {
              carrierId: 1,
              crmId: this.CRMID,
              carrierSpecificId: fn_video_id,
              nickName: this.noNickName,
              headImg: this.userHeadImg,
              contents: this.message
            }, res => {
              if (res.code == 200) {
                this.message = '';
                this.sendSWitch = true;
                this.$toast({
                  duration: 3000,
                  message: '评论成功',
                  context: this
                });
                this.getAllComment(true);
              } else {
                this.message = '';
                this.sendSWitch = true;
                this.$toast({
                  duration: 3000,
                  message: res.message,
                  context: this
                });
              }
            });
          }
        }

      }
    },
    /**
     * @description: 判断真是发送评论的评论框是否展示
     * @param {type}
     * @return:
     */
    isFocusFun() {
      if (this.isGoLogin) {
        this.isLogin()
      } else {
        this.isFocus = true
        // 自动获取焦点
        this.$nextTick(() => {
          $('textarea')[0].focus()
        })
      }
      // this.$refs.submitContent.focus();
    },
    /**
     * @description: 防止视频重复点赞
     * @param {type}
     * @return:
     */
    videoSupport() {
      if (this.isGoLogin) {
        this.isLogin()
      } else {
        let self = this
        let stateLikes = false //防止重复点击
        const { isLike } = this.videolike
        if (!isLike) {
          this.videoLick(() => {
            self.videolike.isLike = true
            self.videolike.likes++
            self.stateLikes = true
          })
        } else {
          this.videoCancelLick(() => {
            self.videolike.isLike = false
            self.videolike.likes--
            self.stateLikes = true
          })
        }
      }
    },
    /**
     * @description: 视频点赞
     * @param {type}
     * @return:
     */
    videoLick (callback) {
      const fn_video_id = Number(location.pathname.replace(/[^0-9]/ig, ""));//当前视频的id
      API.addLikes({}, {
        carrierId: 1,
        carrierSpecificId: fn_video_id,
        crmId: this.CRMID,
        sourceId: 4,
        type: 1
      }, res => {
        if (res.code == "200") {
          this.$toast({
            duration: 3000,
            message: '点赞成功',
            context: this
          });
          callback();
        }
      })
    },
    /**
     * @description: 视频取消点赞
     * @param {type}
     * @return:
     */
    videoCancelLick(callback) {
      const fn_video_id = Number(location.pathname.replace(/[^0-9]/gi, '')) //当前视频的id
      API.cancelLikes(
        {},
        {
          carrierId: 1,
          carrierSpecificId: fn_video_id,
          crmId: this.CRMID,
          sourceId: 4,
          type: 1,
        },
        (res) => {
          if (res.code == '200') {
            callback()
          }
        }
      )
    },
    /**
     * @description: 分享当前视频
     * @param {type}
     * @return:
     */
    shaCurrentVideo() {
      let self = this
      return new Promise((resolve, reject) => {
        // 取视频id
        this.curVideoId = Number(location.pathname.replace(/[^0-9]/gi, ''))
        // 分享的url
        let shareurl =
          window.location.origin +
          window.location.pathname +
          '?shareFrom=wxHfShare'
        // 分享的配置信息
        var shareDataParams = {
          shareLink: shareurl,
          shareDesc: '星妈会特邀哈佛大学育儿专家，陪您一路升级打怪，科学养娃！',
          shareTitle: this.videoDetail.videoTitle,
          imgUrl: 'https://image-mom.feihe.com/wxshare/hafoyuer.png', //必须是绝对路径
          contentId: this.curVideoId,
        }
        hfwxJsSet.wxShare(shareDataParams, this, () => {
          if (this.UserInfo) {
            // 解锁视频
            if (this.getCookie('xmh_nickname')) {
              this.noNickName = this.getCookie('xmh_nickname')
            } else {
              let iphoneNumber = String(this.UserInfo.mobile)
              this.noNickName = '微信用户' + iphoneNumber.substr(7, 11)
            }
            API.shareUnlock({}, {
              "carrierId": 1,
              "carrierSpecificId": this.curVideoId,
              "crmId": this.CRMID,
              "grade": this.gread.grade.code,
              "nickName": this.noNickName,
              "sourceId": 4
            }, res => {
              if (res.code == 200) {
                self.HFshare(false);
                self.initHFVideo();
                const id = Number(location.pathname.replace(/[^0-9]/ig, ""));//当前视频的id
                const time = this.videoDetail.videoDuration.split(":")[0] * 60 + this.videoDetail.videoDuration.split(":")[1] * 1 - 1
                sensors.track('UnlockedVideo', {
                  content_id: id,
                  content_title: this.videoDetail.videoTitle,
                  author: '',
                  length_of_time: time,
                  content_topic: this.currentTopicList.topicTitle,
                  page_name: this.$route.meta.title,
                });
              } else {
                self.HFshare(false);
              }
            })
          } else {
            this.$toast({
              duration: 3000,
              message: '分享成功',
              context: this,
            })
          }
        })
        resolve()
      })
    },
    /**
     * @description: 点击弹出分享引导
     * @param {state} HFshareVideo DOM
     * @param {type} HFshareVideo DOM 1是首屏分享，2是底栏分享
     * @return: null
     */
    HFshare(state, type) {
      if (state) {
        // 判断是为了分享的时候视频会在最高层遮住视频引导文案，只有在视频实例存在的时候再执行此方法
        if ($('video').length > 0) {
          this.$refs.HFVideo.Player.pause()
          $('#HF').css(
            'background-image',
            'url(' + this.videoDetail.videoImg + ')'
          )
          $('video').css('display', 'none')
          $('.xgplayer-controls').css('opacity', '0')
        }
        this.$refs.HFshareVideo.showShareVideo()
      } else {
        this.$refs.HFshareVideo.closeShareVideo()
      }
      let gradeName = this.gread ? this.gread.grade.name : '未登录'

    },
    /**
     * @description: 判断是否需要展示关注引导
     * @param {type}
     * @return:
     */
    isFollow(callback) {
      let openId = this.getCookie('xmh_openid')
      API.isFollow(
        {
          openId: openId,
        },
        (res) => {
          if (res.code == 200) {
            if (res.data) {
              this.isFollowPublic = false
            } else {
              this.isFollowPublic = true
              callback()
            }
          }
        }
      )
    },
    /**
     * @description: 点击屏幕关闭评论输入框
     * @param {type}
     * @return:
     */
    closeCommentInput(e) {
      let isclick =
        $(e.target).attr('id') != 'centerComment' &&
        $(e.target).attr('class') != 'input-item' &&
        $(e.target).attr('class') != 'SendOut' &&
        $(e.target).attr('class') != 'van-cell van-field' &&
        $(e.target).attr('class') != 'van-field__control'
      if (isclick) {
        //    this.isFocus = false;
      }
    },
    fomatterNum,
    is_weixin,
    getCookie,
    setCookie,
  },
  components: {
    HFVideo,
    allVideo,
    allComment,
    HFshare,
    featuresCard,
    Follow,
    commentField,
  },
}
</script>
